import { RateListItem } from '@malesia/json-schema';
import { createActionsColumn } from '@malesia/react-components/dist/src/components/Table/columns/actionsColumn';
import * as layouts from './actions';

export const rateActionsColumn = createActionsColumn<RateListItem, typeof layouts>({
    columnsNumber: 2,
    rowsNumber: 1,
    layouts,
    order: [
        'editRate',
    ],
});
export type RateActionsConfig = Parameters<typeof rateActionsColumn>[0];
